import React, { useState, useContext, useRef, useEffect } from 'react';
import { Text } from '../Text';
import { FormContext } from '../Form/index.js';
import "./index.css";
import moment from 'moment';




export function Input({
  style, 
  large, 
  small, 
  white,
  inputStyle, 
  label, 
  name, 
  type, 
  outline,
  value:initialValue,
  onChange, 
  className, 
  ...props
}) {
  
  const form = useContext(FormContext);
  
  if(!initialValue && form && name) {
    initialValue = form.get(name);
  }
  
  const [value, _setValue] = useState(initialValue || "");

  function setValue(val="") {
    _setValue(val);
    if(onChange) {
      onChange(val);
    }
    else if(form && name) {
      form.set(name, val);
    }
  }
  
  return (
    <div style={style} className={`input ${className}`}>
      {label && 
        <Text bold white={white} block small style={{marginBottom:4}}>
          {label}
        </Text>
      }
      <input 
        type={type || 'text'}
        value={value}
        onChange={e => setValue(e.target.value)}
        style={{
          boxSizing: 'border-box',
          display: 'block',
          width: '100%',
          padding: large ? '8px' : 
                   '4px 8px',
          fontFamily: 'MontserratLight',
          fontSize: large ? 20 : 
                    small ? 12 : 
                    16, 
          color: '#243746',
          lineHeight: '32px',
          backgroundColor: '#ffffff',
          border: outline ? '1px solid #aaa' : 0,
          boxShadow: outline ? 'none' : '0 2px 2px rgba(0,0,0,0.3)',
          ...inputStyle,
        }}
        {...props}
      />
    </div>
  );
}

export function InputPassword(props) {
  return (
    <Input 
      type="password"
      {...props}
    />
  );
}

export function InputDate({value, onChange, ...props}) {
  const date = value ? moment(value) : moment();
  const [formattedValue, setFormattedValue] = useState(date.format("MM/DD/YYYY"));
  
  function isValid(str) {
    const regex = /\d\d\/\d\d\/\d\d\d\d/gm;
    return regex.test(str);
  }
   
  function handleChange(val) {
    setFormattedValue(val);
    if(isValid(val)) {
      const newDate = moment(val, "MM/DD/YYYY");
      onChange(newDate.valueOf());
    }
  }
  
  return (
    <Input 
      value={formattedValue}
      onChange={handleChange}
      placeholder="MM/DD/YYYY"
      {...props}
    />
  );
}


export function InputHTML({
  value:initialValue, 
  onChange, 
  name,
  large, 
  small,
  outline,
  inputStyle,
  ...props
}) {
  
  const inputRef = useRef();
  const form = useContext(FormContext);
  
  if(!initialValue && form && name) {
    initialValue = form.get(name);
  }
  
  useEffect(() => {
    inputRef.current.innerHTML = initialValue || "<div></div>";
  }, []);// eslint-disable-line 
  
  // Note: I'm simply disabling the warning that `initialState` is a missing
  // dependency of useEffect because I only want this component to be uncontrolled 
  // or the cursor goes nutso. What's the better way of doing this? 
  
  function emitValue() {
    if(!inputRef.current) {
      return;
    }
    
    let html = inputRef.current.innerHTML;
    html = html
      .replace(/ ?contenteditable="true" ?/, '')
      .replace(/ ?data-placeholder=".+" ?/, '')
      .replace(/ ?data-name=".+" ?/, '');
  
    if(onChange) {
      onChange(html);
    }
    else if(form && name) {
      form.set(name, html);
    }
  }
  
  return (
    <div
      onInput={emitValue}
      style={{
        boxSizing: 'border-box',
        display: 'block',
        width: '100%',
        padding: large ? '8px' : 
                 '4px 8px',
        fontFamily: 'MontserratLight',
        fontSize: large ? 20 : 
                  small ? 12 : 
                  16, 
        color: '#243746',
        lineHeight: '1.2em',
        backgroundColor: '#ffffff',
        border: outline ? '1px solid #aaa' : 0,
        boxShadow: outline ? 'none' : '0 2px 2px rgba(0,0,0,0.3)',
        ...inputStyle,
      }}>

      <div contentEditable="true" ref={inputRef} style={{outline:'none', minHeight:32, flex:1}}/>

    </div>
  );
}